export default __webpack_public_path__ + "static/media/thumbnail-w-cushion@3x.449fd568.png";